export enum Jurisdiction {
  US = 'US',
  UK = 'UK',
  EU = 'EU',
  CA = 'CA',
  CN = 'CN',
  AU = 'AU',
  NZ = 'NZ',
  IN = 'IN',
  SK = 'SK',
  CZ = 'CZ',
  IE = 'IE',
  CH = 'CH',
  FR = 'FR',
  BX = 'BX',
  JP = 'JP',
  TR = 'TR',
  SG = 'SG',
  HK = 'HK',
  DE = 'DE',
  BD = 'BD',
  BR = 'BR',
  MX = 'MX',
  NO = 'NO',
  ZA = 'ZA',
  KR = 'KR',
  IT = 'IT',
  ES = 'ES',
  TH = 'TH',
  ID = 'ID',
  DK = 'DK',
  TW = 'TW',
  AR = 'AR',
  IL = 'IL',
  PL = 'PL',
  PT = 'PT',
  BG = 'BG',
  EE = 'EE',
  GE = 'GE',
  KZ = 'KZ',
  LT = 'LT',
  LV = 'LV',
  RO = 'RO',
  UA = 'UA',
  VN = 'VN',
  SE = 'SE',
  FI = 'FI',
  HU = 'HU',
  AT = 'AT',
  SI = 'SI',
  HR = 'HR',
  CO = 'CO',
  EC = 'EC',
  PE = 'PE',
  MC = 'MC',
  AD = 'AD',
  EG = 'EG',
  JO = 'JO',
  KE = 'KE',
  LB = 'LB',
  MA = 'MA',
  NG = 'NG',
  PK = 'PK',
  TN = 'TN',
  TZ = 'TZ',
  ME = 'ME',
  PY = 'PY',
  BO = 'BO',
  UY = 'UY',
  VE = 'VE',
  AM = 'AM',
  AZ = 'AZ',
  KG = 'KG',
  MD = 'MD',
  TJ = 'TJ',
  TM = 'TM',
  UZ = 'UZ',
  DZ = 'DZ',
  KH = 'KH',
  LA = 'LA',
  AO = 'AO',
  BI = 'BI',
  CV = 'CV',
  DJ = 'DJ',
  CD = 'CD',
  ER = 'ER',
  ET = 'ET',
  GH = 'GH',
  MG = 'MG',
  MU = 'MU',
  OA = 'OA',
  AP = 'AP',
  AE = 'AE',
  CL = 'CL',
  MY = 'MY',
  PH = 'PH',
  SA = 'SA',
  KW = 'KW',
  OM = 'OM',
  QA = 'QA',
  BA = 'BA',
  BH = 'BH',
  PA = 'PA',
  IS = 'IS',
  CY = 'CY',
}

export enum NotOfferedJurisdiction {
  WO = 'WO',
}

export const directFilingJurisdictions: string[] = [
  Jurisdiction.EU,
  Jurisdiction.UK,
  Jurisdiction.US,
  Jurisdiction.AU,
  Jurisdiction.CH,
  Jurisdiction.IE,
  Jurisdiction.NZ,
  Jurisdiction.SK,
  Jurisdiction.CZ,
  Jurisdiction.BX,
]

export enum CountryOrJurisdictionSelectionType {
  allJurisdictions = 'all-jurisdictions',
  supportedJurisdictions = 'supported-jurisdictions',
  countries = 'countries',
  custom = 'custom',
}

export const highPriorityJurisdictions = [Jurisdiction.US, Jurisdiction.UK, Jurisdiction.EU]
export const lowPriorityJurisdictions = [Jurisdiction.AP, Jurisdiction.OA]
export const draftingFilingJurisdictions: string[] = [Jurisdiction.EU, Jurisdiction.UK]

export const getDefaultsForJurisdictions = <T>(defaultValue: T): Record<Jurisdiction, T> =>
  Object.fromEntries(
    Object.values(Jurisdiction).map((jurisdiction) => [jurisdiction, defaultValue]),
  ) as Record<Jurisdiction, T>
